import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CalendarModule, CalendarDateFormatter, DateFormatterParams } from '../shared/angular-calendar';
import { TranslateModule } from '@ngx-translate/core';
import { FullCalendarModule } from 'ng-fullcalendar';
import { ResizableModule } from 'angular-resizable-element';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { DemoUtilsModule } from '../appointments/dashboard/demo-utils/module';
import { ApplicationPipes } from '../shared/pipes/TimeFormatPipe';
import { TooltipModule, ModalModule } from 'ngx-bootstrap';
import { SelectModule } from 'ng-select';
import { DashboardDataService } from '../appointments/dashboard/dashboard-data.service';
import { DashboardSubject } from '../appointments/dashboard/dashboard-subject';
import { MyDayViewComponent } from '../appointments/dashboard/my-calendar-day-view.component';
import { AppointmentsService } from '../appointments/appointments.service';
import { RecruiterCancelComponent } from './recruiter-cancel.component';
import { MultiUploadRecruiterComponent } from './multi-upload/multi-upload-recruiter.component';
//import { CloudinaryModule, Cloudinary } from '@cloudinary/angular-4.x';
import { FileUploadModule } from 'ng2-file-upload';
// import { CloudinaryWidgetModule } from '../shared/directives/cloudinary/coudinary-widget.module';
import { ClipboardModule } from 'ngx-clipboard';
import { QuillModule } from 'ngx-quill';
import { environment } from '../../environments/environment';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FroalaEditorOptions } from '../shared/services/template-froala-options';
import { SharedModule } from '../shared/shared.module';
import { ClickOutsideModule } from 'ng-click-outside';
// export const cloudinaryLib = {
//     Cloudinary: Cloudinary
//   };

export class CustomDateFormatter extends CalendarDateFormatter {

    public dayViewHour({date, locale}: DateFormatterParams): string {
        return new Intl.DateTimeFormat('nl', {
          hour: 'numeric',
          minute: 'numeric'
        }).format(date);
      }
 }
 
@NgModule({
    declarations: [
        RecruiterCancelComponent,
        MultiUploadRecruiterComponent
    ],
    imports: [
        CommonModule,     
        ReactiveFormsModule,
        FormsModule,
        CalendarModule.forRoot(),
        TranslateModule,
        FullCalendarModule,
        ResizableModule,
        ModalModule.forRoot(),
        DragAndDropModule,
        DemoUtilsModule,
        ApplicationPipes,
        TooltipModule.forRoot(),
        SelectModule,
        ClipboardModule,
        QuillModule,
        // CloudinaryModule.forRoot(cloudinaryLib, {
        //     cloud_name: environment.cloudinaryConfiguration.cloud_name,
        //     upload_preset: environment.cloudinaryConfiguration.upload_preset
        //   }),
          // CloudinaryWidgetModule,
          FileUploadModule,
          FroalaEditorModule.forRoot(),
          FroalaViewModule.forRoot(),
          SharedModule,
          ClickOutsideModule
    ],
    providers: [
        AppointmentsService,
        DashboardDataService,
        DashboardSubject,
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter
         },
         FroalaEditorOptions
    ],
    entryComponents:[]
})

export class RecruiterCancelModule { }


// WEBPACK FOOTER //
// ./src/app/recruiter-cancel/recruiter-cancel.module.ts